import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { StyleGuideComponent } from './style-guide.component';
import { StyleGuideRoutingModule } from './style-guide-routing.module';

@NgModule({
    imports: [
        CommonModule,
        NgbTooltipModule,
        SharedModule,        
        StyleGuideRoutingModule
    ],
    declarations: [
        StyleGuideComponent
    ],
    providers: [
    ]
})
export class StyleGuideModule { }
